/* template */
<template><div :style="[(styleBackgroundColor)] | transRpxStyle" class="error-page"><mpx-view :style="[(styleRule)] | transRpxStyle" @tap="goRulePage" class="rule" v-if="(isShowRule)">规则</mpx-view><mpx-image :src="(styleBackgroundImg)" mode="widthFix" class="error-image"/><div class="error-content"><mpx-image src="https://dpubstatic.udache.com/static/dpubimg/3GcYtLCWHZQqxFKWwcgeh.png" mode="widthFix" class="error-icon"/><div class="error-text">{{
        message || '活动太火爆了，请稍后重试'
      }}</div><div class="redirect-text" v-if="(countdown > 0)">即将为您跳转最新活动<span>({{ countdown }}s)…</span></div></div></div></template>

/* styles */
<style lang="scss" scoped mpxStyleOptions='{"mid":"m5bdcb2a1"}'>
  .error-page {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    padding-bottom: 44rpx;
  }
  .rule {
    position: absolute;
    width: 84rpx;
    height: 37rpx;
    right: 0;
    border-radius: 27rpx 0 0 27rpx;
    font-family: AlibabaPuHuiTi_2_65_Medium;
    font-size: 24rpx;
    line-height: 37rpx;
    letter-spacing: 1rpx;
    text-align: center;
    font-weight: 500;
  }
  .error-image {
    width: 100%;
    height: auto;
    margin-bottom: -140rpx;
  }
  .error-content {
    width: 700rpx;
    height: 1080rpx;
    background: #ffffff;
    border-radius: 36rpx;
    text-align: center;
  }
  .error-icon {
    margin-top: 60rpx;
    width: 163rpx;
    height: 163rpx;
  }
  .error-text {
    margin-top: 20rpx;
    font-family: PingFangSC-Regular;
    font-size: 27rpx;
    color: #333333;
    letter-spacing: 0.9rpx;
    text-align: center;
    line-height: 60rpx;
    font-weight: 400;
  }
  .redirect-text {
    font-family: PingFangSC-Regular;
    font-size: 24rpx;
    color: #f18d56;
    letter-spacing: 0.8rpx;
    text-align: center;
    line-height: 60rpx;
    font-weight: 400;
  }
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m5bdcb2a1"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./error-page.mpx.js?async=error-page&isComponent&outputPath=components%2Ferror-page5bdcb2a1%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./error-page.mpx?async=error-page&ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Ferror-page5bdcb2a1%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m5bdcb2a1"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/error-page5bdcb2a1/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
